import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import { BestyPricingCalculator } from "./components/BFFCalc/BFFCalc";
import { BestyPricingCalculatorExternal } from "./components/BFFCalc/BFFCalcExternal";

import { BookingPage } from "./components/BookingPage/BookingPage";
import { BookingPageConf } from "./components/BookingPageConf/BookingPage";
import { NewFeatures } from "./components/NewFeature/NewFeatures";
import Report from "./components/ReportBuilder/index";
import { BestyCalcR } from "./components/Vreact/BestyCalcR";
import MessageStats from "./components/MessageStats/MessageStats";
import { BestyPricingCalculatorEuro } from "./components/BFFCalc/BFFCalcEuro";
import { OPSCalculator } from "./components/BFFCalc/OPSCalc";
import { OPSCalculatorExternal } from "./components/BFFCalc/OPSCalcExternal";

const CompWrapper = () => {
  return (
    <div className="compWrapper">
      <BestyCalcR />
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<CompWrapper />} />
          <Route path="/copilot" element={<NewFeatures />} />
          <Route path="/demo-booking" element={<BookingPage />} />
          <Route path="/conference" element={<BookingPageConf />} />
          <Route path="/bffcalc-euro" element={<BestyPricingCalculatorEuro />} />
          <Route path="/report" element={<Report />} />
          <Route path="/bffcalc" element={<BestyPricingCalculator />} />
          <Route path="/bffcalculator" element={<BestyPricingCalculatorExternal />} />
          <Route path="/opscalc" element={<OPSCalculator />} />
          <Route path="/opscalculator" element={<OPSCalculatorExternal />} />
          <Route path="/message-stats" element={<MessageStats />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
